// Central, reusable SEO configuration for every public page.
// Adding a new page = add an entry here + render <Seo page="key" /> — all tags auto-generate.
// Product pages use PRODUCT_SEO (in content.js) keyed by slug.

export const PAGES = {
  home: {
    path: '/',
    title: 'CRGO Transformer Core Manufacturer | Banmore Electricals',
    description:
      'Banmore Electricals manufactures CRGO transformer core laminations, slit coils, cut-to-length laminations and assembled transformer cores for customers worldwide.',
    keywords:
      'CRGO Transformer Core, CRGO Transformer Lamination, Transformer Core Manufacturer India, CRGO Slit Coil, Electrical Steel, Built-up Transformer Core',
    h1: 'CRGO Transformer Core Manufacturer in India',
    type: 'website',
  },
  products: {
    path: '/products',
    title: 'CRGO Laminations, Slit Coils & Transformer Cores | Banmore',
    description:
      'Explore CRGO transformer laminations, slit coils, mother coils and built-up transformer core assemblies from Banmore Electricals, a leading Indian manufacturer.',
    keywords:
      'CRGO Transformer Lamination, CRGO Slit Coils, Built-up Transformer Core Assembly, CRGO Mother Coils, Transformer Core products',
    h1: 'CRGO Transformer Core Products',
    type: 'website',
  },
  about: {
    path: '/about',
    title: 'About Banmore Electricals | CRGO Core Manufacturer India',
    description:
      'Founded in 1977, Banmore Electricals is a three-generation manufacturer and exporter of CRGO transformer core laminations and built-up cores from India.',
    keywords:
      'Banmore Electricals, CRGO Transformer Core Manufacturer, Transformer Lamination company India, Star Export House CRGO',
    h1: 'About Banmore Electricals',
    type: 'website',
  },
  infrastructure: {
    path: '/infrastructure',
    title: 'CRGO Manufacturing Infrastructure | Banmore Electricals',
    description:
      "Fully automated CNC cut-to-length and slitting lines up to 1250 mm, in-house CRGO testing lab and 900 MT per month capacity at Banmore Electricals' India facility.",
    keywords:
      'CRGO manufacturing infrastructure, CNC cut to length lines, CRGO slitting capacity, transformer core factory India, electrical steel processing India',
    h1: 'CRGO Manufacturing Infrastructure',
    type: 'website',
  },
  manufacturingProcess: {
    path: '/manufacturing-process',
    title: 'CRGO Transformer Core Manufacturing Process | Banmore',
    description:
      "From prime CRGO coil sourcing and precision slitting to CNC cutting, step-lap core building, loss testing and export dispatch — Banmore's six-stage process.",
    keywords:
      'CRGO manufacturing process, transformer core manufacturing, CRGO cut to length process, core building process, electrical steel processing',
    h1: 'CRGO Transformer Core Manufacturing Process',
    type: 'website',
  },
  qualityAssurance: {
    path: '/quality-assurance',
    title: 'Quality Assurance & CRGO Testing | Banmore Electricals',
    description:
      'ISO 9001:2015 systems, IS 649/3024 compliance, PGCIL and NTPC approval, and in-house CRGO loss testing ensure guaranteed quality at Banmore Electricals.',
    keywords:
      'CRGO quality assurance, transformer core testing, ISO 9001 CRGO, IS 649 compliance, CRGO loss testing India',
    h1: 'CRGO Quality Assurance & Testing',
    type: 'website',
  },
  exportMarkets: {
    path: '/export-markets',
    title: 'CRGO Transformer Core Exporter India | Banmore Electricals',
    description:
      'A Government of India Star Export House, Banmore Electricals exports CRGO transformer core laminations and assembled cores to 16 countries across 5 continents.',
    keywords:
      'CRGO lamination exporter India, transformer core exporter, CRGO core export, electrical steel exporter India, Star Export House CRGO',
    h1: 'CRGO Transformer Core Export Markets',
    type: 'website',
  },
  career: {
    path: '/career',
    title: 'Careers at Banmore Electricals | CRGO Core Manufacturer',
    description:
      'Build your career with Banmore Electricals, a leading CRGO transformer core manufacturer in India. Join our engineering and manufacturing team.',
    keywords: 'careers Banmore Electricals, CRGO manufacturer jobs India, transformer core jobs',
    h1: 'Careers at Banmore Electricals',
    type: 'website',
  },
  contact: {
    path: '/contact',
    title: 'Contact Banmore Electricals | CRGO Transformer Core India',
    description:
      'Contact Banmore Electricals for CRGO transformer laminations, slit coils and built-up cores. Call or WhatsApp +91 9329212724.',
    keywords:
      'Contact Banmore Electricals, CRGO Transformer Core supplier, Transformer Lamination inquiry, CRGO manufacturer contact',
    h1: 'Contact Banmore Electricals',
    type: 'website',
  },
};
